import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export const UploadArrowIcon: FC<IconProps> = ({ className, iconColor = '#344054', ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33325 14.166V15.8327C3.33325 16.2747 3.50885 16.6986 3.82141 17.0112C4.13397 17.3238 4.55789 17.4993 4.99992 17.4993H14.9999C15.4419 17.4993 15.8659 17.3238 16.1784 17.0112C16.491 16.6986 16.6666 16.2747 16.6666 15.8327V14.166"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M5.83325 7.50065L9.99992 3.33398L14.1666 7.50065"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M10 3.33398V13.334"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
